var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 .75c7.525 0 14.337 3.05 19.269 7.981A27.165 27.165 0 0 1 55.25 28c0 7.525-3.05 14.337-7.981 19.269A27.165 27.165 0 0 1 28 55.25a27.165 27.165 0 0 1-19.269-7.981A27.165 27.165 0 0 1 .75 28c0-7.525 3.05-14.337 7.981-19.269A27.165 27.165 0 0 1 28 .75z",
    stroke: "#272726",
    strokeWidth: 1.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 31.86a4.475 4.475 0 0 0-3.619 1.856l-7.063-3.666a4.623 4.623 0 0 0-.147-3.002l7.403-4.518a4.464 4.464 0 0 0 3.426 1.61c2.481 0 4.5-2.05 4.5-4.57 0-2.52-2.019-4.57-4.5-4.57S31 17.05 31 19.57c0 .583.108 1.14.305 1.653l-7.422 4.528a4.462 4.462 0 0 0-3.383-1.56c-2.481 0-4.5 2.05-4.5 4.57 0 2.52 2.019 4.571 4.5 4.571a4.477 4.477 0 0 0 3.659-1.913l7.043 3.656A4.62 4.62 0 0 0 31 36.43c0 2.52 2.019 4.57 4.5 4.57s4.5-2.05 4.5-4.57c0-2.52-2.019-4.57-4.5-4.57zm0-15.337c1.654 0 3 1.367 3 3.047 0 1.68-1.346 3.047-3 3.047s-3-1.367-3-3.047c0-1.68 1.346-3.047 3-3.047zm-15 15.286c-1.654 0-3-1.367-3-3.047 0-1.68 1.346-3.047 3-3.047s3 1.367 3 3.047c0 1.68-1.346 3.047-3 3.047zm15 7.668c-1.654 0-3-1.367-3-3.047 0-1.68 1.346-3.047 3-3.047s3 1.367 3 3.047c0 1.68-1.346 3.047-3 3.047z",
    fill: "#272726",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3a02fdb74917002c0df13834d4e8cccb.svg";
export { ForwardRef as ReactComponent };